// extracted by mini-css-extract-plugin
module.exports = {"resetIcon":"UsersTable_resetIcon__1UxBC","container":"UsersTable_container__wtDYT","tableContainer":"UsersTable_tableContainer__ZLjuD"};